import React from 'react'
import { IndexLink, Link } from 'react-router'
import './style.scss'

export default class MenuButton extends React.Component {
	constructor(props) {
		super(props);
	}

	button(type) {
		switch(type) {
			case 'home': return {
				text: 'Home',
				class: ' home'
			};
			case 'match': return {
				text: 'Match Tests',
				class: ' match'
			};
			case 'status': return {
				text: 'Update Status',
				class: ' status'
			};
			case 'setting': return {
				text: 'Settings',
				class: ' setting'
			};
			case 'signup': return {
				text: 'Create Account',
				class: ' signup'
			};
			case 'admin': return {
				text: 'Super Admin',
				class: ' admin'
			};
			case 'exit': return {
				text: 'Exit Admin',
				class: ' exit'
			};
		}
	}

	render() {
		return (
			<Link to={this.props.href} activeClassName='button-active'>
				<div className={'header-button' + (this.button(this.props.type).class)}>
					<div className='header-button-icon' />
					<div className='header-button-text'>{this.props.text}</div>
					{ this.props.badge && <div className='header-badge'></div> }
				</div>
			</Link>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/MenuButton/index.js